<template>
  <div class>
    <div class="header-banner">
      <Header class="home-header" :isLogin="true" />
      <HeaderM class="home-header-m" :isLogin="true" />
      <Banner />
    </div>
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>地区国别
    </h2>
    <div class="w1200">
      <div class="sec1-o-list">
        <ul class="list-box">
          <li class="lst-item" @click="changeCountry('意大利')">
            <i class="icon1 icon11"></i>
            <h3 class="fs-rem26 h3tit">意大利</h3>
          </li>
          <li class="lst-item" @click="changeCountry('德国')">
            <i class="icon1 icon12"></i>
            <h3 class="fs-rem26 h3tit">德国</h3>
          </li>
          <li class="lst-item" @click="changeCountry('芬兰')">
            <i class="icon1 icon13"></i>
            <h3 class="fs-rem26 h3tit">芬兰</h3>
          </li>
          <li class="lst-item" @click="changeCountry('瑞典')">
            <i class="icon1 icon14"></i>
            <h3 class="fs-rem26 h3tit">瑞典</h3>
          </li>
          <li class="lst-item" @click="changeCountry('挪威')">
            <i class="icon1 icon15"></i>
            <h3 class="fs-rem26 h3tit">挪威</h3>
          </li>
          <li class="lst-item" @click="changeCountry('加拿大')">
            <i class="icon1 icon16"></i>
            <h3 class="fs-rem26 h3tit">加拿大</h3>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <SourceMatch ref="sm" :projectList="projectList"/>
      <div class="category-container">
        <div class="category-item">
          <div class="cateroty-title-wrapper">
            <p class="cateroty-title">数字化机构</p>
          </div>
          <div class="category-list-product">
            <div v-for="p,index in resaultlist" :key="index" class="category-list-product-item">
              <div class="cover-container item-top">
                <img @click="openDetail(p.orgid)" :src="p.logo" alt="">
              </div>
              <div class="item-bottom">
                <p class="name1">{{p.organization}}</p>
                <div class="company-container margin-top">
                  <span class="company cu-tag line-blue">{{p.industrycategory}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="category-item">
          <div class="cateroty-title-wrapper">
            <p class="cateroty-title">聘专家</p>
          </div>
          <div class="category-list-product">
            <div v-for="p,index in specailList" :key="`p${index}`" class="category-list-product-item">
              <div class="cover-container item-top">
                <img class="specialImg" @click="formatUrl(p.url)" :src="p.img" alt="">
              </div>
              <div class="item-bottom">
                <p class="name2 special-name">{{p.title}}</p>
                <!-- <div class="company-container">
                  <span class="company">{{p.subtitle}}</span>
                </div> -->
              </div>
              <div class="bottom">
                <div class="left">新基建领域：</div>
                <div class="right">{{p.subtitle}}</div>
                <!-- {{item.industry_category}} -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer :isLogin="true" />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import HeaderM from '@/components/HeaderM.vue';
  import Nav from '@/components/Nav.vue';
  import Footer from '@/components/Footer.vue';
  import Banner from '@/components/main/Banner.vue';
  import SourceMatch from '@/components/main/SourceMatch.vue';
  import {
    orglistbynation,
    getRecommentSikeRoad
  } from '@/api/oneRoad.js'
  import config from '@/config/index';
  export default {
    name: 'oneroad',
    components: {
      Nav,
      Header,
      HeaderM,
      Footer,
      Banner,
      SourceMatch
    },
    mounted() {
      this.$refs.sm.p_init()
      this.getorglistbynation()
      this.getStaticData()
    },
    data() {
      return {
        resaultlist: [],
        country: "意大利",
        specailList:[],
        projectList:[]
      }
    },
    methods: {
      openDetail(sid) {
        this.$router.push('/detail/org-detail?orgid=' + sid);
      },
      formatUrl(endurl){
        let url = `${config.BASE_URL}#/${endurl}`
        window.location.href= url
      },
      getStaticData() {
        this.$http.get(getRecommentSikeRoad()).then(res => {
          if (res.code === 1) {
            for (var i = 0; i < res.data.length; i++) {
              if(res.data[i].type===3){
                res.data[i].img = `${config.HOST_IMG}${res.data[i].img}`
                this.specailList.push(res.data[i])
              }else{
                this.projectList.push(res.data[i])
              }
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
      },
      changeCountry(country) {
        if(country!='意大利'){
          this.$message.warning(`${country}数据未开放展示`);
          return
        }
        this.country = country
        this.getorglistbynation()
      },
      getorglistbynation() {
        const district = this.country
        const page = 1
        const limit = 10
        this.$http.get(orglistbynation(), {
          district,
          page,
          limit,
        }).then(res => {
          if (res.code === 1) {
            this.resaultlist = []
            this.count = res.data.count
            var list = res.data.list
            var item;
            for (var i = 0; i < list.length; i++) {
              item = list[i]
              var img = item.logo
              item.logo = `${config.HOST_IMG}${img}`
              this.resaultlist.push(item)
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    },
  }
</script>

<style scoped>
  @import url("OneRoadView.css");
  @import url("Home.css");
  @import url(../mainui.css);
.main {
  margin-bottom: 1.5rem;
}
.special-name{
    height: 30px;
  	display: -webkit-box;
  	-webkit-box-orient: vertical;
  	-webkit-line-clamp: 1;
  	overflow: hidden;
  }

  h2 {
    text-align: center;
    margin: 20px 0 20px
  }

  .cateroty-title-wrapper {
    padding: .28rem .28rem .17rem .48rem;
    box-sizing: border-box;
  }

  .cateroty-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
    border-left: solid 2px #267FF2;
    padding-left: 10px;
    line-height: .17rem;
  }

  .category-list-product {
    margin-left: 40px;
    margin-right: 20px;
  }

  .category-list-product-item {
    width: 2.3rem;
    height: 3.28rem;
    border: 1px solid rgba(217, 217, 217, 1);
    box-sizing: border-box;
    display: inline-block;
  }

  .specialImg {
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 50%;
  }

  .category-list-product-item:not(:nth-child(5n)) {
    margin-right: .12rem;
  }

  .category-list-product-item:nth-child(6n) {
    margin-top: 10px;
  }

  .category-list-product-item .cover-container {
    height: 2.08rem;
    padding: 0.1rem 0.1rem 0.1rem 0.1rem;
  }

  .category-list-product-item .cover-container img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border: solid #C0C0C0 0.5px;
  }

  .name2 {
    font-size: 20px;
    color: #267FF2;
  }

  .name1 {
    font-size: 20px;
  }

  .category-list-product-item .item-bottom {
    padding: .16rem .14rem .19rem .14rem;
    margin-top: 0rem;
  }

  .category-list-product-item .item-bottom .btn-m {
    display: none;
  }

  .category-list-product-item .bottom {
    display: flex;
    margin-top: 0rem;
  }

  .category-list-product-item .bottom div {
    /* display: inline-block; */
    padding: .08rem .08rem;
    color: #fff;
  }


  .category-list-product-item .bottom .left {
    position: relative;
    width: 1rem;
    background: linear-gradient(322deg, #FEE4DF 0%, #F76A4A 100%);
  }

  .category-list-product-item .bottom .left::after,
  .category-list-product-item .bottom .left::before {
    height: 0px;
    width: 0px;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
    border-color: transparent #63A3F6 transparent transparent;
    border-style: solid solid solid solid;
    border-width: 22px 22px 0px 0px;
    position: absolute;
    content: ' ';
    top: 15px;
    right: 0;
  }

  .category-list-product-item .bottom .left::before {
    top: 0;
    transform: rotate(-90deg);
  }

  .category-list-product-item .bottom .right {
    flex: 1;
    background: linear-gradient(280deg, #B8D5FB 0%, #63A3F6 100%);
  }

  @media screen and (max-width: 850px) {
    .home-header {
      display: none !important;
    }

    .home-header-m {
      display: block;
    }
  }
</style>
